import { render, staticRenderFns } from "./repair-order-statistics.vue?vue&type=template&id=4a5abf65&scoped=true"
import script from "./repair-order-statistics.vue?vue&type=script&lang=js"
export * from "./repair-order-statistics.vue?vue&type=script&lang=js"
import style0 from "./repair-order-statistics.vue?vue&type=style&index=0&id=4a5abf65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5abf65",
  null
  
)

export default component.exports